<template>
    <div>
        <div class="setting-wrapper">
            <div class="setting">
                <h4 class="lg:w-1/5">
                    {{ lang('Enskilda kanaler','Individual channels') }}
                </h4>

                <div class="w-full">
                    <div class="w-full flex flex-col px-2xl py-xl">
                        <div class="flex w-full items-center" :class="{ 'mb-xl': toggled }">
                            <span>
                                {{ lang('Saknar du någon kanal? Välj bland våra fristående','Missing a channel? Choose between our stand-alone') }}
                                {{ lang('kanaler som exempelvis Yle eller Viasat Golf','channels like Yle or Viasat Golf ') }}
                            </span>

                            <a
                                class="ml-auto flex items-center mt-xl lg:relative lg:mt-0 text-neutral-darker read-more"
                                :class="{ 'is-active' : toggled }"
                                @click="toggle"
                            >
                                <font-awesome-icon icon="chevron-down" class="chevron text-sm lg:text-lg" />
                            </a>
                        </div>

                        <div v-if="toggled" class="flex flex-wrap -m-sm">
                            <div
                                v-for="tvChannel in tvChannels"
                                class="flex text-center border border-neutral-light p-sm m-sm w-1/2 md:w-1/6"
                            >
                                <checkbox-input
                                    v-model="localSelectedTvChannels"
                                    :value="tvChannel.article_id"
                                >
                                    <div class="flex flex-col">
                                        <div class="px-2xl md:px-0">
                                            <img
                                                v-tooltip.top="tvChannel.name"
                                                :src="tvChannel.image"
                                                :alt="tvChannel.name"
                                                style="max-height: 34px;"
                                            >
                                        </div>
                                        <div class="text-sm">
                                            <div class="text-helper">{{ tvChannel.name }}</div>
                                            {{ format_sek_per_month(tvChannel.monthly_price) }}
                                        </div>
                                    </div>
                                </checkbox-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        model: {
            prop: 'selectedTvChannels',
            event: 'input',
        },
        props: {
            tvChannels: {
                type: Array,
                required: true,
            },
            selectedTvChannels: {
                type: Array,
                required: false,
                default: () => [],
            },
        },
        data() {
            return {
                toggled: false,
                selectedCheckBox: [],
            };
        },
        computed: {
            localSelectedTvChannels: {
                get() {
                    return this.selectedTvChannels;
                },
                set(newValues) {
                    this.$emit('input', newValues);
                },
            },
        },
        methods: {
            toggle() {
                this.toggled = ! this.toggled;
            },
        },
    };
</script>